module.exports = __webpack_public_path__ + "img/38.762b087f.jpg";